"use strict";

exports.__esModule = true;
exports.FIELD_ERROR_URL = exports.FIELD_ERROR_SLUG = exports.FIELD_ERROR_UPLOADING = exports.FIELD_ERROR_REQUIRED = void 0;
var FIELD_ERROR_REQUIRED = 'required';
exports.FIELD_ERROR_REQUIRED = FIELD_ERROR_REQUIRED;
var FIELD_ERROR_UPLOADING = 'uploading';
exports.FIELD_ERROR_UPLOADING = FIELD_ERROR_UPLOADING;
var FIELD_ERROR_SLUG = 'slug';
exports.FIELD_ERROR_SLUG = FIELD_ERROR_SLUG;
var FIELD_ERROR_URL = 'url';
exports.FIELD_ERROR_URL = FIELD_ERROR_URL;